import React from 'react';

import { hot } from 'react-hot-loader/root';

import GoogleAnalyticsLandingHelmet from 'common/helmets/GoogleAnalyticsLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import GoogleAnalyticsLogo from 'img/landing/google-analytics-logo.webp';

import CannyLogoIcon from 'img/canny-icon.svg';

import 'css/components/integrations/_IntegrationsLanding.scss';

const GoogleAnalyticsLanding = () => {
  return (
    <div className="integrationsLanding withoutImage">
      <GoogleAnalyticsLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={GoogleAnalyticsLogo}
                alt="Google Analytics Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Google Analytics Extension</h1>
              <p className="subtitle">
                Track and analyze the traffic you’re getting to your Canny board.
              </p>
              <div className="links">
                <InstallExtensionButton
                  installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fgoogle-analytics"
                  installButtonText="Install Extension"
                />
                <a
                  href="https://help.canny.io/en/articles/3635989-google-analytics"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Understand where your feedback comes&nbsp;from</h2>
              <p className="subtitle">
                Use Google Analytics’ acquisition reports to pinpoint channels that bring you
                traffic.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">See how users interact with your Canny&nbsp;portal</h2>
              <p className="subtitle">
                How long do users spend looking at your changelog entries? What feature requests get
                the most views? Find out with this integration!
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Dive into user attributes</h2>
              <p className="subtitle">
                Uncover valuable insights about your users. Google Analytics 4 can tell you about
                users’ location, language, age, and even interests.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default hot(GoogleAnalyticsLanding);
